import { z } from "zod";

export const EntityResponsabilitySchema = z.object({
    isOnwer: z.boolean().default(false),
    isManager: z.boolean().default(false),
    isTender: z.boolean().default(false),
});

export type EntityResponsability = z.infer<typeof EntityResponsabilitySchema>;